
//#region [Main] Constants

export const constants = {
  ALL        : 'CORRECT-ALL',
  EXCEPTIONS : 'CORRECT-EXCEPTIONS',
  HYBRID     : 'CORRECT-HYBRID'
}

//#endregion

//#region [Main] Actions

export const actions = {
  correctAll,
  correctExceptions,
  correctHybrid
};

function correctAll() {
  return { type: constants.ALL };
}

function correctExceptions() {
  return { type: constants.EXCEPTIONS };
}

function correctHybrid() {
  return { type: constants.HYBRID };
}

//#endregion

//#region [Main] Reducers

const initialState = constants.EXCEPTIONS;

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.ALL:
      return constants.ALL;
    case constants.EXCEPTIONS:
      return constants.EXCEPTIONS;
    case constants.HYBRID:
      return constants.HYBRID;
    default:
      return state
  }
}

//#endregion


//#region [purple] hooks



//#endregion